// extracted by mini-css-extract-plugin
module.exports = {"top":"SafeArea_top__jKfi2","bottom":"SafeArea_bottom__TqAu6"};